export interface JsonLayerResponse {
  success: boolean;
  message?: string;
}

export function isJsonLayerResponse(unknownValue: unknown): unknownValue is JsonLayerResponse {
  return (
    typeof unknownValue === 'object' &&
    unknownValue !== null &&
    'success' in unknownValue &&
    typeof unknownValue.success === 'boolean' &&
    (!('message' in unknownValue) || typeof unknownValue.message === 'string')
  );
}
